import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoAutocompleteDirective } from './no-autocomplete.directive';


@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        NoAutocompleteDirective,
    ],
    exports: [
        NoAutocompleteDirective,
    ],
})
export class NoAutocompleteModule { }

